import { Component as ReactComponent, ComponentType } from 'react';
import { UserStateService } from '../../auth/services/UserStateService';
import { PageLoader } from '../components/PageLoader';
import { AuthUserContext } from '../services/AuthUserContext';
import { VersionService } from '../services/VersionService';

type WithAuthUserProps = {};

type WithAuthUserState = {
  loaded: boolean;
};

export const withAuthUser = (Component: ComponentType) => {
  return class extends ReactComponent<WithAuthUserProps, WithAuthUserState> {
    private readonly versionService = new VersionService();
    private readonly userStateService = new UserStateService();

    constructor(props: WithAuthUserProps, context: unknown) {
      super(props, context);

      this.state = { loaded: false };
    }

    componentDidMount() {
      this.init();
    }

    componentWillUnmount() {
      this.versionService.cancelAllRequests();
      this.userStateService.cancelAllRequests();
    }

    async init() {
      let version = null;
      try {
        version = await this.versionService.getVersion();
      } catch {
        // do nothing, we can live without it
      }

      try {
        const user = await this.userStateService.getUser();

        AuthUserContext.setUser(user);
        AuthUserContext.setVersion(version);

        this.setState({ loaded: true });
      } catch (e: unknown) {
        this.setState(() => {
          // Force the error to go through `ErrorBoundary`
          throw e;
        });
      }
    }

    render() {
      if (!this.state.loaded) {
        return <PageLoader />;
      }
      return <Component {...this.props} />;
    }
  };
};
